package com.essntl.features.task.ui.alltasks

import androidx.compose.runtime.Composable
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.uikit.rememberFind

@Composable
fun AllTasksState.rememberCategory(id: String?) : CategoryModel? {
    return rememberFind(
        getAllCategory.data.orEmpty(),
        id,
    ) { category -> category.id }
}